import React from 'react';
import type { Density, FieldGroup } from '../../types/disclosure';
import { FieldList } from './FieldList';
interface FieldGroupBlockProps {
  group: FieldGroup;
  density: Density;
  showApiNames: boolean;
  /** Max number of columns the field rows flow across on wide screens. */
  columns?: 1 | 2 | 3;
}
export function FieldGroupBlock({
  group,
  density,
  showApiNames,
  columns = 1
}: FieldGroupBlockProps) {
  const hasHeader = Boolean(group.title || group.description || group.condition);
  return <section aria-label={group.title} data-id="element-1" data-mp="3n6ka4f4hf6x8">
      {hasHeader && <div className="mb-1.5 border-b border-slate-200 pb-1" data-id="element-2" data-mp="3n3prmt513w6g">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-3" data-mp="395rgdwm08fv6">
            {group.title && <h3 className="text-[11px] font-semibold uppercase tracking-wide text-slate-600" data-id="element-4" data-mp="3e3szghjfkf6n">
                {group.title}
              </h3>}
            {group.condition && <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700 ring-1 ring-inset ring-emerald-200" data-id="element-5" data-mp="22rs60pbmg2kk">
                Applied
                <span className="font-normal normal-case tracking-normal text-emerald-800/70" data-id="element-6" data-mp="3esvz56uiee8t">
                  {group.condition}
                </span>
              </span>}
          </div>
          {group.description && <p className="mt-0.5 text-xs text-slate-500" data-id="element-7" data-mp="5lcooc7wh0a1">{group.description}</p>}
        </div>}

      <FieldList fields={group.fields} density={density} showApiNames={showApiNames} columns={columns} data-id="element-8" data-mp="1kj3hqludzku" />
    </section>;
}